import { useEffect, useState } from 'react';

const usePagePath = () => {
  const [path, setPath] = useState('');
  useEffect(() => {
    if (typeof window === 'undefined') return;
    setPath(window.location.pathname);
  }, []);

  return path;
};

export default usePagePath;
